import { render, staticRenderFns } from "./RecoverAccount.vue?vue&type=template&id=29661c0e&scoped=true&"
import script from "./RecoverAccount.vue?vue&type=script&lang=js&"
export * from "./RecoverAccount.vue?vue&type=script&lang=js&"
import style0 from "./RecoverAccount.vue?vue&type=style&index=0&id=29661c0e&lang=scss&scoped=true&"
import style1 from "styles/dashboard/style.scss?vue&type=style&index=1&id=29661c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29661c0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29661c0e')) {
      api.createRecord('29661c0e', component.options)
    } else {
      api.reload('29661c0e', component.options)
    }
    module.hot.accept("./RecoverAccount.vue?vue&type=template&id=29661c0e&scoped=true&", function () {
      api.rerender('29661c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/RecoverAccount.vue"
export default component.exports